module.exports = __webpack_public_path__ + "images/marcelo-0eaf41c8d85cde701a206f907be5571671a42ffb.jpg";